export default __webpack_public_path__ + "static/media/twitter.df3f1777.svg";